export type TBreakPoints = "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";

export const BREAKPOINTS_NUM: { [keys in TBreakPoints]: number } = {
  sm: 540,
  md: 720,
  lg: 960,
  xl: 1140,
  "2xl": 1280,
  "3xl": 1600,
};

export const BREAKPOINTS: { [keys in TBreakPoints]: string } = {
  sm: `${BREAKPOINTS_NUM.sm}px`,
  md: `${BREAKPOINTS_NUM.md}px`,
  lg: `${BREAKPOINTS_NUM.lg}px`,
  xl: `${BREAKPOINTS_NUM.xl}px`,
  "2xl": `${BREAKPOINTS_NUM["2xl"]}px`,
  "3xl": `${BREAKPOINTS_NUM["3xl"]}px`,
};
